import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "store/hooks";
import {
  isSmallScreen,
  sidebarState,
  sidebarToggleState,
} from "store/selectors";
import { onResize, onToggle, toggleChange } from "store/slices/sidebarSlice";

export function useDispatchSidebarState() {
  const dispatch = useAppDispatch();
  const sidebarCollapsedState = useAppSelector(sidebarState);
  const sidebarToggleCurrentState = useAppSelector(sidebarToggleState);
  const isSmallScreenState = useAppSelector(isSmallScreen);

  useEffect(() => {
    const handleResize = () => {
      const windowWidth = window.innerWidth;
      if (windowWidth <= 992) {
        dispatch(onResize({ isSmallScreen: true, screenSize: windowWidth }));
        dispatch(toggleChange(true));
      } else {
        dispatch(onResize({ isSmallScreen: false, screenSize: windowWidth }));
        dispatch(toggleChange(false));
        dispatch(onToggle(false));
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Run on component mount

    return () => window.removeEventListener("resize", handleResize); // Cleanup
  }, []);

  return {
    sidebarCollapsedState,
    sidebarToggleCurrentState,
    isSmallScreenState,
  };
}
